import { PanelStore } from '../interfaces';

export namespace CheckoutThemeSelectors {
  export const getLoading = (state: PanelStore.RootState) => {
    return state.checkoutThemes.loading;
  };
  export const getFormLoading = (state: PanelStore.RootState) => {
    return state.checkoutThemes.formLoading;
  };
  export const getError = (state: PanelStore.RootState) => {
    return state.checkoutThemes.error;
  };
  export const getErrorInfo = (state: PanelStore.RootState) => {
    return state.checkoutThemes.errorInfo;
  };
  export const getAllCheckoutThemes = (state: PanelStore.RootState) => {
    return state.checkoutThemes.allCheckoutThemes;
  };
  export const getShowCreateCheckoutTheme = (state: PanelStore.RootState) => {
    return state.checkoutThemes.showCreateCheckoutTheme;
  };
  export const getRequestSuccess = (state: PanelStore.RootState) => {
    return state.checkoutThemes.requestSuccess;
  };
  export const getUpdateCheckoutTheme = (state: PanelStore.RootState) => {
    return state.checkoutThemes.updateTheme;
  };
  export const getCheckoutPhoneRequired = (state: PanelStore.RootState) => {
    return state.checkoutThemes.checkoutPhoneRequired;
  };
  export const getPhoneRequiredLoading = (state: PanelStore.RootState) => {
    return state.checkoutThemes.phoneRequiredLoading;
  };
  export const getPhoneRequiredSaving = (state: PanelStore.RootState) => {
    return state.checkoutThemes.phoneRequiredSaving;
  };
  export const getPhoneRequiredSuccess = (state: PanelStore.RootState) => {
    return state.checkoutThemes.phoneRequiredSuccess;
  };
}
